function initListsIndex(): void {
  const backdrop = document.getElementById("modalBackdrop");
  if (!backdrop) return;

  const openCreate = document.getElementById("openCreate");
  const closeModal = document.getElementById("closeModal");
  const cancelModal = document.getElementById("cancelModal");
  const modalTitle = document.getElementById("modalTitle");
  const listName = document.getElementById(
    "listName",
  ) as HTMLInputElement | null;
  const listDesc = document.getElementById(
    "listDesc",
  ) as HTMLTextAreaElement | null;
  const listForm = document.getElementById(
    "listForm",
  ) as HTMLFormElement | null;

  function openModal(title: string): void {
    if (modalTitle) modalTitle.textContent = title;
    if (backdrop) {
      backdrop.style.display = "flex";
      backdrop.setAttribute("aria-hidden", "false");
    }
    setTimeout(() => listName?.focus(), 0);
  }
  function hideModal(): void {
    if (backdrop) {
      backdrop.style.display = "none";
      backdrop.setAttribute("aria-hidden", "true");
    }
    if (openCreate instanceof HTMLElement) {
      openCreate.focus();
    }
    if (listForm) listForm.reset();
  }
  if (openCreate)
    openCreate.addEventListener("click", () => {
      openModal("Create list");
    });

  if (closeModal) closeModal.addEventListener("click", hideModal);
  if (cancelModal) cancelModal.addEventListener("click", hideModal);
  backdrop.addEventListener("click", (e: MouseEvent) => {
    if (e.target === backdrop) hideModal();
  });

  function setPatchMethod(form: HTMLFormElement): void {
    let m = form.querySelector<HTMLInputElement>('input[name="_method"]');
    if (!m) {
      m = document.createElement("input");
      m.type = "hidden";
      m.name = "_method";
      form.appendChild(m);
    }
    m.value = "patch";
  }

  document.querySelectorAll<HTMLElement>("[data-rename-id]").forEach((btn) => {
    btn.addEventListener("click", (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const id = btn.getAttribute("data-rename-id");
      const name = btn.getAttribute("data-rename-name");
      const desc = btn.getAttribute("data-rename-desc") || "";
      const csrf = btn.getAttribute("data-rename-csrf");

      // Fill form
      if (listName) listName.value = name || "";
      if (listDesc) listDesc.value = desc;

      // Switch form to UPDATE mode
      if (listForm) {
        listForm.action = `/lists/${id}`;
        setPatchMethod(listForm);

        const csrfInput =
          (document.getElementById("listCsrf") as HTMLInputElement | null) ||
          listForm.querySelector<HTMLInputElement>(
            'input[name="authenticity_token"]',
          );

        if (csrfInput && csrf) csrfInput.value = csrf;
      }

      openModal("Rename list");
    });
  });
  document.querySelectorAll<HTMLElement>("[data-delete-id]").forEach((btn) => {
    btn.addEventListener("click", (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const id = btn.getAttribute("data-delete-id");
      const name = btn.getAttribute("data-delete-name");
      const csrf = btn.getAttribute("data-delete-csrf");

      if (!confirm(`Delete list "${name}"?`)) return;

      const form = document.createElement("form");
      form.method = "post";
      form.action = `/lists/${id}`;

      const token = document.createElement("input");
      token.type = "hidden";
      token.name = "authenticity_token";
      token.value = csrf || "";

      const method = document.createElement("input");
      method.type = "hidden";
      method.name = "_method";
      method.value = "delete";

      form.appendChild(token);
      form.appendChild(method);

      document.body.appendChild(form);
      form.submit();
    });
  });

  document.addEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Escape") hideModal();
  });
}

document.addEventListener("turbo:load", initListsIndex);
document.addEventListener("DOMContentLoaded", initListsIndex);
